import React, { useState } from 'react';
import logo from '../assets/logo/transparent_logo.png';
import { FiUser, FiEdit2 } from 'react-icons/fi';
import { useI18n } from '../useI18n.js';
import LanguageSwitch from '../components/LanguageSwitch';
import { GAME_MODES } from '../gameModes';

// Couleur de theme par mode (miroir des :root[data-tgr-mode] dans discord.css).
const MODE_COLORS = {
  classic: '#22c55e', chrono: '#8b5cf6', discussion: '#3b82f6',
  mashup: '#FF9F1C', blindtest: '#ec4899', studio: '#ef4444',
};

// Hub d'accueil unifie : creer / rejoindre, identite, vitrine des modes.
// Le profil detaille (ELO, stats, classement) vit dans le modal global LoginBadge.
export function HomeHub({ pseudo, onJoin, onPseudoChange }) {
  const { t } = useI18n();
  const [code, setCode] = useState('');
  const [editing, setEditing] = useState(!pseudo);
  const [tmp, setTmp] = useState(pseudo || '');

  const ensureName = () => { if (pseudo) return true; setTmp(''); setEditing(true); return false; };
  const create = () => { if (!ensureName()) return; onJoin(Math.floor(100000 + Math.random() * 900000).toString()); };
  const join = () => { if (code.length === 6 && ensureName()) onJoin(code); };
  const saveName = () => { const v = (tmp || '').trim().slice(0, 16); if (v) { onPseudoChange(v); setEditing(false); } };

  return (
    <div className="home-hub">
      <div className="hub-lang"><LanguageSwitch /></div>

      <header className="hub-top">
        <img src={logo} alt="Logo TerraGuessr" className="hub-logo" />
        <h1>{t('appTitle')}</h1>
        <button type="button" className="hub-pseudo" onClick={() => { setTmp(pseudo || ''); setEditing(true); }}>
          <FiUser aria-hidden="true" /> <span>{pseudo || t('home_choose_nickname')}</span> <FiEdit2 aria-hidden="true" className="hp-edit" />
        </button>
      </header>

      <main className="hub-play">
        <button type="button" className="hub-create" onClick={create}>
          <span className="hc-plus">+</span> {t('createRoom')}
        </button>
        <div className="hub-or"><span>{t('or') || 'ou'}</span></div>
        <div className="hub-join">
          <input
            className="hub-code"
            inputMode="numeric"
            placeholder="------"
            value={code}
            maxLength={6}
            aria-label={t('roomsCodePlaceholder')}
            onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 6))}
            onKeyDown={(e) => { if (e.key === 'Enter') join(); }}
          />
          <button type="button" className="hub-join-btn" disabled={code.length !== 6} onClick={join}>{t('join')}</button>
        </div>
      </main>

      <footer className="hub-modes">
        {GAME_MODES.map((m) => (
          <div key={m.id} className="hub-mode" style={{ '--mc': MODE_COLORS[m.id] || 'var(--color-primary)' }}>
            <span className="hm-emoji">{m.emoji}</span>
            <span className="hm-name">{t(m.nameKey)}</span>
          </div>
        ))}
      </footer>

      <div className="hub-legal">
        <a href="#/privacy">{t('privacy') || 'Confidentialite'}</a>
        <span aria-hidden>·</span>
        <a href="#/terms">{t('terms') || 'Conditions'}</a>
        <span aria-hidden>·</span>
        <a href="mailto:lukykyh.v1@gmail.com">Contact</a>
      </div>

      {editing && (
        <div className="modal-overlay" onClick={() => pseudo && setEditing(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2 style={{ marginTop: 0 }}>{t('home_choose_nickname')}</h2>
            <input
              autoFocus
              value={tmp}
              maxLength={16}
              placeholder={t('home_nickname_placeholder')}
              onChange={(e) => setTmp(e.target.value.slice(0, 16))}
              onKeyDown={(e) => { if (e.key === 'Enter') saveName(); }}
            />
            <div style={{ marginTop: '0.75rem', display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
              {pseudo && <button type="button" onClick={() => setEditing(false)}>{t('cancel')}</button>}
              <button type="button" onClick={saveName} disabled={!tmp.trim()}>{t('confirm')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomeHub;
